import React from "react";
import { User, LogOut } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from "../ui/dropdown-menu";
import { Avatar, AvatarFallback } from "../ui/avatar";
import { cn } from "../../lib/utils";

export function UserProfileDropdown({
  userInitials = "RH",
  userImage,
  userName = "Rossie",
  showProfile = true,
  onProfileClick,
  onLogoutClick,
  className = "",
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            "focus-visible:ring-misc-focus focus-visible:ring-[2px] focus-visible:ring-offset-1 rounded-full select-none",
            className
          )}
        >
          <Avatar className="w-10 h-10 p-2 flex justify-center items-center bg-secondary-6 border border-secondary-6 cursor-pointer">
            {/* <AvatarImage
                            src={userImage || "/placeholder.svg"}
                            alt={userName}
                        /> */}
            <AvatarFallback className="text-secondary-2 text-base font-normal ">
              {userInitials}
            </AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {showProfile && (
          <DropdownMenuItem className="gap-2" onSelect={() => onProfileClick?.()}>
            <User className="w-4 h-4 text-primary-3" />
            <span>Profile</span>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem className="gap-2" onSelect={() => onLogoutClick?.()}>
          <LogOut className="w-4 h-4 text-primary-3" />
          <span>Log Out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
